<template>
  <div class="mt-10">
    <h2 class="text-truncate font-weight-bold text-h5 mb-4">{{ $t('Billing') }}</h2>
    <div
        v-if="(transactions && !transactions.length) && !loading"
        class="pa-3 d-flex align-center"
    >
        <v-icon>mdi-file-document-outline</v-icon>
        <p class="mb-0 ml-2 text-subtitle-1">
            {{ $t('You do not have any transactions') }}.
        </p>
    </div>

    <template v-if="transactions && transactions.length">
        <transactions-with-pagination
            :transactions="transactions"
            :pagination="pagination"
            :overwrite-path="url"
            @load="load"
        />
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import TransactionsWithPagination from './TransactionsWithPagination.vue';

export default {
  components: {
    TransactionsWithPagination,
  },
  data() {
    return {
      transactions: [],
      pagination: {},
      url: '/transactions',
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapGetters(['loading']),
  },
  methods: {
    load(url = this.url) {
      this.$store.dispatch('loading', true);
      axios
        .get(url)
        .then(({ data }) => {
          this.pagination = data;
          this.transactions = data.data && data.data.length ? data.data : data;
          this.$store.dispatch('loading', false);
          this.$nextTick(() => {
            this.$store.dispatch('startBusinessBillingGuideFlow', {
              routeName: this.$route.name,
              router: this.$router,
            });
          });
        })
        .catch(() => {
          this.$store.dispatch('loading', false);
        });
    },
  },
};
</script>
